var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 7H9C7.67441 7.00159 6.40356 7.52888 5.46622 8.46622C4.52888 9.40356 4.00159 10.6744 4 12L4 20C4.00159 21.3256 4.52888 22.5964 5.46622 23.5338C6.40356 24.4711 7.67441 24.9984 9 25H23C24.3256 24.9984 25.5964 24.4711 26.5338 23.5338C27.4711 22.5964 27.9984 21.3256 28 20V12C27.9984 10.6744 27.4711 9.40356 26.5338 8.46622C25.5964 7.52888 24.3256 7.00159 23 7ZM9 9H23C23.7956 9 24.5587 9.31607 25.1213 9.87868C25.6839 10.4413 26 11.2044 26 12H6C6 11.2044 6.31607 10.4413 6.87868 9.87868C7.44129 9.31607 8.20435 9 9 9ZM23 23H9C8.20435 23 7.44129 22.6839 6.87868 22.1213C6.31607 21.5587 6 20.7956 6 20V14H26V20C26 20.7956 25.6839 21.5587 25.1213 22.1213C24.5587 22.6839 23.7956 23 23 23Z",
    fill: "url(#paint0_linear_3591_14785)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3591_14785",
    x1: 4,
    y1: 26.9286,
    x2: 29.8275,
    y2: 19.3027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarCard);
export default __webpack_public_path__ + "static/media/avatar-card.f346e76d7b3f5d8c79fa68604ebfcc50.svg";
export { ForwardRef as ReactComponent };